import { ref } from "vue";

export const isHandlingHubAccessRequired = ref(false);

export const getEffectiveAuthToken = (): string | null => {
  return localStorage.getItem("FCHT") || localStorage.getItem("tokenAdb2c");
};

export const setIsHandlingHubAccessRequired = (value: boolean): void => {
  isHandlingHubAccessRequired.value = value;
};

export const getIsHandlingHubAccessRequired = (): boolean => {
  return isHandlingHubAccessRequired.value;
};

let isHandlingSessionExpired = false;

export const setIsHandlingSessionExpired = (value: boolean): void => {
  isHandlingSessionExpired = value;
};

export const getIsHandlingSessionExpired = (): boolean => {
  return isHandlingSessionExpired;
};

export const storeFchTokenFromUrl = (): string | null => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const fchTokenParamNames = [process.env.VUE_APP_TEXT, "FCHT"].filter((paramName): paramName is string => Boolean(paramName));
  const fchTokenParamName = fchTokenParamNames.find(paramName => urlParams.has(paramName));
  const fchToken = fchTokenParamName ? urlParams.get(fchTokenParamName) : null;

  if (!fchToken || !fchTokenParamName) return null;

  localStorage.setItem("FCHT", fchToken);

  const url = new URL(window.location.href);
  url.searchParams.delete(fchTokenParamName);
  window.history.replaceState({}, "", url);

  return fchToken;
};
